module.exports = __webpack_public_path__ + "27e40681a208685d3ee4cd382d5654f4.fbx";